module.exports = __webpack_public_path__ + "static/media/papertrail-logo-simple.5067f124.svg";